import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "devices" */ './index'),
  loading: () => null,
})
